import spartacusOnboardingAPI from '@api/jooicez-backend/spartacus/onboarding';
import orange from '@assets/onboarding-spartacus-v2/clinic-orange.png';
import Iconify from '@components/iconify';
import { Box, Button, CircularProgress, Stack, TextField, Typography } from '@mui/material';
import icons from '@utils/icons';
import { useState } from 'react';
import { useApp } from 'src/contexts/ApplicationContext';
import { useResponsive } from 'src/hooks/use-responsive';

import { StepProps } from './steps';

export default function BusinessNameStep({ onNext }: StepProps) {
  const [businessName, setBusinessName] = useState('');
  const { setOrganizationId } = useApp();
  const [isLoading, setIsLoading] = useState(false);
  const isMobile = useResponsive('down', 'sm');

  const handleContinue = async () => {
    setIsLoading(true);
    try {
      const org = await spartacusOnboardingAPI.createOrganization({ businessName });
      setOrganizationId(org.organizationId);
      spartacusOnboardingAPI.createBrand(org.organizationId, { businessName }).catch((error) => {
        console.error('Error creating brand:', error);
      });
      onNext();
    } catch (error) {
      console.error('Error creating organization:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        pt: { xs: 4, sm: 0 },
        gap: { xs: 3, sm: 4 },
        position: 'relative',
      }}
    >
      <img
        src={orange}
        alt="Clinic"
        style={{
          width: isMobile ? '120px' : '200px',
          position: 'fixed',
          bottom: 20,
          ...(isMobile ? { right: 0 } : { left: 20 }),
        }}
      />
      {/* Flex spacers bias the content to the upper third on desktop (no fixed paddings) */}
      <Box sx={{ display: { xs: 'none', sm: 'block' }, flexGrow: 2 }} />
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 0.5 }}>
        <Typography variant={isMobile ? 'h2' : 'h1'} color="text.primary">
          Let&apos;s start with your clinic.
        </Typography>
        <Typography variant={isMobile ? 'h2' : 'h1'} sx={{ color: 'secondary.darker' }}>
          What&apos;s its name?
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%', maxWidth: 400 }}>
        <TextField
          sx={{ width: '100%', maxWidth: 400 }}
          label="Your clinic name"
          value={businessName}
          onChange={(e) => setBusinessName(e.target.value)}
        />
        <Button
          variant="contained"
          color="primary"
          size="large"
          disabled={!businessName.trim()}
          onClick={handleContinue}
          endIcon={!isLoading ? <Iconify icon={icons.arrows.right} /> : undefined}
          fullWidth
        >
          {isLoading ? (
            <Stack direction="row" spacing={1} alignItems="center">
              <CircularProgress size={16} color="inherit" />
              <span>Saving...</span>
            </Stack>
          ) : (
            'Continue'
          )}
        </Button>
      </Box>
      <Box sx={{ display: { xs: 'none', sm: 'block' }, flexGrow: 3 }} />
    </Box>
  );
}
